import { Link, useLocation } from "react-router-dom";
import { CalendarDays, MessageCircle } from "lucide-react";
import { useSiteSettings, waLinkFrom } from "@/lib/siteData";

/** Única chamada pública ao WhatsApp; botão fixo no rodapé do celular. */
export default function MobileActions() {
  const settings = useSiteSettings();
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin") || pathname.startsWith("/demonstracao")) return null;
  return (
    <nav
      aria-label="Ações rápidas do Jet Paradise"
      className="fixed inset-x-0 bottom-0 z-40 flex w-full items-center gap-3 border-t border-neon-cyan/25 bg-ocean/95 px-4 pt-3 pb-[max(12px,env(safe-area-inset-bottom))] shadow-[0_-10px_30px_rgba(0,0,0,0.35)] backdrop-blur md:hidden"
    >
      <Link
        to="/demonstracao"
        data-testid="mobile-simular-reserva"
        className="flex min-h-[52px] min-w-0 flex-[1.15] items-center justify-center gap-2 rounded-2xl bg-neon-cyan px-3 text-center font-display text-[11px] font-black uppercase tracking-wide text-ocean transition-transform duration-150 active:scale-[0.97] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-neon-cyan"
      >
        <CalendarDays size={18} aria-hidden="true" className="shrink-0"/>
        <span>Simular reserva</span>
      </Link>
      <a
        href={waLinkFrom(settings)}
        target="_blank"
        rel="noreferrer"
        data-testid="mobile-whatsapp"
        className="flex min-h-[52px] min-w-0 flex-1 items-center justify-center gap-2 rounded-2xl border border-neon-wa/60 bg-neon-wa/10 px-3 text-center font-display text-[11px] font-extrabold uppercase tracking-wide text-neon-wa transition-transform duration-150 active:scale-[0.97] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-neon-wa"
      >
        <MessageCircle size={19} aria-hidden="true" className="shrink-0"/>
        <span>WhatsApp</span>
      </a>
    </nav>
  );
}
